export default __webpack_public_path__ + "static/media/vishumoney.982bb67a.jpeg";